import React, { createContext, useContext, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { ModelAddRepository } from "../../repository/AdminDashboard/DeviceModelRepository";
import { useNavigate } from "react-router-dom";
import { ModelDetailRepository } from "../../repository/AdminDashboard/DeviceModelRepository";

const StateContext = createContext();

const initialState = {
  model: {
    name: "",
    price: "",
    seri: "",
    updateNumber: "",
    environment: "",
    useType: "",
    testType: "",
    connectionProtocol: "",
    HealthRule: "",
    connectionType: "",
    SpeakerStatus: "",
    lightstatus: "",
    releStatus: "",
    sensore: [],
  },
  editmodel: {
    id: "",
    name: "",
    price: "",
    seri: "",
    updateNumber: "",
    environment: "",
    useType: "",
    testType: "",
    connectionProtocol: "",
    HealthRule: "",
    connectionType: "",
    SpeakerStatus: "",
    lightstatus: "",
    releStatus: "",
    sensore: [],
  },
};

const ModelAddContext = ({ children }) => {
  const [username, setusername] = useState("");
  const [serialnumber, setserialnumber] = useState("");
  const [Seriname, setSeriname] = useState("");
  const [updatename, setUpdatename] = useState("");
  const [formattedNumber, setFormattedNumber] = useState("");
  const [environment, setenvironment] = useState("");
  const [useType, setuseType] = useState("");
  const [testType, settestType] = useState("");
  const [protocol, setprotocol] = useState("");
  const [healthrules, sethealthrules] = useState("");
  const [Connection, setConnection] = useState("");
  const [speakertype, setspeakertype] = useState("");
  const [lighttype, setlighttype] = useState("");
  const [rele, setrele] = useState("");
  const [sensors, setsensors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quality, setquality] = useState(false);
  const [editdata, seteditdata] = useState({});
  const [id, setid] = useState("");

  // dynamic form
  const [inputForms, setInputForms] = useState([
    {
      id: "",
      username: "",
      jsonname: "",
      measurunit: "",
      maxIndex: "",
      minIndex: "",
      maxValue: "",
      minValue: "",
    },
  ]);

  // Function to fetch model data
  const getdata = async (id_id) => {
    setLoading(true);

    const data = await ModelDetailRepository.getDetail(id_id);

    if (data.code == 1) {
      seteditdata(data.details);
      setInputForms(data.details.sensore);
      if (data.details.testType === "کیفیت سنج") {
        setquality(false);
      } else {
        setquality(true);
      }
      setid(id_id);
      setLoading(false);
      updateSerialNumber(
        data.details.seri ?? "",
        data.details.updateNumber ?? ""
      );
    } else if (data.code === 0) {
      navigate("/device/models");
      setTimeout(() => {
        toast.error(data.message, {
          className: "text-12 text-dark-blue-200",
        });
      }, 1000);
    }
  };

  // Navigation hook
  const navigate = useNavigate();

  // send new model's data
  const senddata = async (data, sonsorData) => {
    const newData = {
      ...data,
      sensore: sonsorData,
    };
    const modelAdd = await ModelAddRepository.modelAddedit(newData);
    setLoading(true);
    if (modelAdd.code == 1) {
      navigate("/admin/device/models");
      setTimeout(() => {
        toast.success(modelAdd.status, {
          className: "text-12 text-dark-blue-200",
        });
        setLoading(false);
      }, 1000);
    } else if (modelAdd.code == 0) {
      toast.error(modelAdd.status, {
        className: "text-12 text-dark-blue-200",
      });
      setLoading(false);
    }
  };

  //   dynamic form
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedInputForms = [...inputForms];
    updatedInputForms[index][name] = value;
    setInputForms(updatedInputForms);
  };

  // function to handle add model done
  const handleAddForm = () => {
    const newForm = {
      id: Date.now(),
      username: "",
      jsonname: "",
      measurunit: "",
      maxIndex: "",
      minIndex: "",
      maxValue: "",
      minValue: "",
    };
    setInputForms([...inputForms, newForm]);
  };

  // function to handle edit model done
  const handledoneedit = async () => {
    const inputObjects = inputForms.map((input) => {
      if (quality == false) {
        return {
          username: input.username,
          jsonname: input.jsonname,
          measurunit: input.measurunit,
          maxIndex: input.maxIndex,
          minIndex: input.minIndex,
          maxValue: input.maxamount,
          minValue: input.minamount,
        };
      } else if (quality == true) {
        return {
          username: input.username,
          jsonname: input.jsonname,
          measurunit: input.measurunit,
          maxValue: input.maxamount,
          minValue: input.minamount,
        };
      }
    });

    setsensors(inputObjects);
    await senddata(initialState.editmodel, inputObjects);
  };

  // handle form submited creat json
  const handleFormSubmit = async () => {
    const inputObjects = inputForms.map((input) => {
      if (quality == false) {
        return {
          username: input.username,
          jsonname: input.jsonname,
          measurunit: input.measurunit,
          maxIndex: input.maxIndex,
          minIndex: input.minIndex,
          maxValue: input.maxamount,
          minValue: input.minamount,
        };
      } else if (quality == true) {
        return {
          username: input.username,
          jsonname: input.jsonname,
          measurunit: input.measurunit,
          maxValue: input.maxamount,
          minValue: input.minamount,
        };
      }
    });

    setsensors(inputObjects);
    await senddata(initialState.model, inputObjects);
  };

  // Function to handle new form added deletation
  const handleDeleteForm = (index) => {
    const a = index;

    setInputForms((previnputForms) => {
      const newData = previnputForms.filter((item, index) => index !== a);

      return newData;
    });
  };
  // inputchange
  const onchangeInput = (event) => {
    const { id, value } = event.target;
    switch (id) {
      case "username":
        setusername(value);
        seteditdata({ ...editdata, name: value });
        break;
      case "seriname":
        setSeriname(value);
        updateSerialNumber(value, updatename); // Assuming updatename is defined
        seteditdata({ ...editdata, seriname: value });
        break;
      case "updatenumbr":
        setUpdatename(value);
        updateSerialNumber(Seriname, value); // Assuming Seriname is defined
        seteditdata({ ...editdata, updatename: value });
        break;
      default:
        break;
    }
  };
  //   create serialnumber
  const updateSerialNumber = (seriname, updatename) => {
    // Get the current year and month
    const year = new Date().getFullYear().toString().substr(-2);
    const month = (new Date().getMonth() + 1).toString().padStart(2, "0");

    // Create the serial number value by concatenating the input values and date
    const serialnumberValue = seriname + updatename + year + month + "01";
    setserialnumber(serialnumberValue);
  };

  //   price input
  const handlepriceChange = (event) => {
    const inputValue = event.target.value;
    const number = Number(inputValue.replace(/,/g, ""));
    const formatted = new Intl.NumberFormat().format(number);
    setFormattedNumber(formatted);
    seteditdata({ ...editdata, price: formatted });
  };

  // onchange select
  const changeenvironment = (event) => {
    if (event.length > 0) {
      setenvironment(event[0].value);
      seteditdata({ ...editdata, environment: event[0].value });
    }
  };

  const changeuseType = (event) => {
    if (event.length > 0) {
      setuseType(event[0].value);
      seteditdata({ ...editdata, useType: event[0].value });
    }
  };

  const changetestType = (event) => {
    if (event.length > 0) {
      settestType(event[0].value);
      seteditdata({ ...editdata, testType: event[0].value });
    }
    if (event[0].value === "مقدار سنج") {
      setquality(true);
    }
    if (event[0].value === "کیفیت سنج") {
      setquality(false);
    }
  };

  const changeprotocol = (event) => {
    if (event.length > 0) {
      setprotocol(event[0].value);
      seteditdata({ ...editdata, protocol: event[0].value });
    }
  };

  const changehealthrules = (event) => {
    if (event.length > 0) {
      sethealthrules(event[0].value);
      seteditdata({ ...editdata, healthruls: event[0].value });
    }
  };

  const changeConnection = (event) => {
    if (event.length > 0) {
      setConnection(event[0].value);
      seteditdata({ ...editdata, connection: event[0].value });
    }
  };

  const changespeakertype = (event) => {
    if (event.length > 0) {
      setspeakertype(event[0].value);
      seteditdata({ ...editdata, speakers: event[0].value });
    }
  };

  const changelighttype = (event) => {
    if (event.length > 0) {
      setlighttype(event[0].value);
      seteditdata({ ...editdata, light: event[0].value });
    }
  };

  const onchangerele = (event) => {
    if (event.length > 0) {
      setrele(event[0].value);
      seteditdata({ ...editdata, rele: event[0].value });
    }
  };

  //   initialstate
  initialState.model.name = username;
  initialState.model.price = formattedNumber;
  initialState.model.seri = Seriname;
  initialState.model.updateNumber = updatename;
  initialState.model.environment = environment;
  initialState.model.useType = useType;
  initialState.model.testType = testType;
  initialState.model.connectionProtocol = protocol;
  initialState.model.HealthRule = healthrules;
  initialState.model.connectionType = Connection;
  initialState.model.SpeakerStatus = speakertype;
  initialState.model.lightstatus = lighttype;
  initialState.model.releStatus = rele;
  initialState.model.sensore = sensors;

  initialState.editmodel.name = editdata.name;
  initialState.editmodel.price = editdata.price;
  initialState.editmodel.seri = editdata.seri;
  initialState.editmodel.updateNumber = editdata.updateNumber;
  initialState.editmodel.environment = editdata.environment;
  initialState.editmodel.useType = editdata.useType;
  initialState.editmodel.testType = editdata.testType;
  initialState.editmodel.connectionProtocol = editdata.conectionProtocol;
  initialState.editmodel.HealthRule = editdata.HealtRule;
  initialState.editmodel.connectionType = editdata.connectionType;
  initialState.editmodel.SpeakerStatus = editdata.SpeakerStatus;
  initialState.editmodel.lightstatus = editdata.lightstatus;
  initialState.editmodel.releStatus = editdata.releStatus;
  initialState.editmodel.sensore = editdata.sensore;
  initialState.editmodel.id = id;

  // select option
  const environmentvalue = [
    { value: "محیط داخلی", label: "محیط داخلی" },
    { value: "محیط خارجی", label: "محیط خارجی" },
  ];

  const useTypevalue = [
    { value: "خانگی", label: "خانگی" },
    { value: "صنعتی", label: "صنعتی" },
  ];
  const testTypevalues = [
    { value: "مقدار سنج", label: "مقدار سنج" },
    { value: "کیفیت سنج", label: "کیفیت سنج" },
  ];
  //   value
  const protocolvalues = [
    { value: "Wi-Fi", label: "Wi-Fi" },
    // { value: "کیفیت سنج", label: "کیفیت سنج" },
  ];
  const healthrulesvalue = [
    { value: "طبق قوانین بهداشتی ویاک", label: "طبق قوانین بهداشتی ویاک" },
    { value: "چک پوینت کاربر", label: "چک پوینت کاربر" },
  ];
  const connectionType = [
    { value: "برق مستقیم DC", label: "برق مستقیم DC" },
    { value: "برق مستقیم AC", label: "برق مستقیم AC" },
  ];

  const speakertypevalue = [
    { value: "دارای اسپیکر", label: "دارای اسپیکر" },
    { value: "بدون اسپیکر", label: "بدون اسپیکر" },
  ];
  const lighttypevalue = [
    { value: "دارای چراغ بر روی دستگاه", label: "دارای چراغ بر روی دستگاه" },
    { value: "بدون چراغ روی دستگاه", label: "بدون چراغ‌ روی دستگاه" },
  ];
  const relestatusvalue = [
    { value: "دارای رله بر روی مدار", label: "دارای رله بر روی مدار" },
    { value: "بدون رله", label: "بدون رله" },
  ];
  return (
    <StateContext.Provider
      value={{
        inputForms,
        handleInputChange,
        handleAddForm,
        handleFormSubmit,
        handledoneedit,
        handleDeleteForm,
        changeConnection,
        onchangeInput,
        changehealthrules,
        changeenvironment,
        changeuseType,
        changetestType,
        changeprotocol,
        changespeakertype,
        changelighttype,
        onchangerele,
        setFormattedNumber,
        serialnumber,
        formattedNumber,
        handlepriceChange,
        quality,
        editdata,
        getdata,
        loading,
        updateSerialNumber,
        environmentvalue,
        useTypevalue,
        testTypevalues,
        protocolvalues,
        healthrulesvalue,
        connectionType,
        speakertypevalue,
        lighttypevalue,
        relestatusvalue,
      }}>
      {children}
    </StateContext.Provider>
  );
};

function useStateContext() {
  return React.useContext(StateContext);
}

export { useStateContext };
export default ModelAddContext;
